<template>
    <div class="lifePercent">
        <div class="publishTime">预报时效{{publishTime}}</div>
        <div class="lifePercentContent">
            <div class="item" v-for="(item, index) in dataArr" :key="index">
                <img :src="require('../../assets/images/life/' + item.imgUrl)" alt="">
                <div class="text">
                    {{item.key}}:{{item.value}}
                </div>
            </div>            
        </div>
    </div>
</template>

<script>
import { home } from '../../api/index'
export default {
    created() {
        this.baseApi = process.env.VUE_APP_BASE_API;
        home.getGZ_livingPercent().then(data => {
            console.log(data);
            this.publishTime = data.ddatetime,
            this.dataArr = [
                {
                    key: '穿衣指数',
                    value: data.dressing.index,
                    imgUrl: '4.png'
                },
                {
                    key: '紫外线',
                    value: data.ultraviolet.level,
                    imgUrl: '1.gif'
                },
                {
                    key: '火险',
                    value: data.fireDanger.level,
                    imgUrl: '3.gif'
                },
                {
                    key: '舒适度',
                    value: data.bodyComfortable.index,
                    imgUrl: '2.png'
                },                {
                    key: '晾晒',
                    value: data.field.index,
                    imgUrl: '5.gif'
                },
                {
                    key: '灰霾',
                    value: data.dustHaze.level,
                    imgUrl: '9.gif'
                },
                {
                    key: '霉变',
                    value: data.mildew.index,
                    imgUrl: '6.gif'
                },
                                {
                    key: '雨伞',
                    value: data.umbrella.umbrella,
                    imgUrl: '10.gif'
                },
                                {
                    key: '负离子浓度',
                    value: data.aeroanion.index,
                    imgUrl: '8.png'
                },
                {
                    key: '交通',
                    value: data.traffic.index,
                    imgUrl: '9.png'
                }
            ]
        })
    },
    data() {
        return {
            // 预报时效
            publishTime: '',

            // 封装数据对象
            dataArr: [],

            baseApi: '',
        }
    }
}
</script>

<style lang="less">
    .lifePercent {
        .publishTime {
            margin-top: 10px;
            text-align: center;
            font-size: 13px;
        }

        .lifePercentContent {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .item {
                width: 45%;
                height: 59px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 8px;
                }
            }
        }    
    }
</style>